// test823
(823 && 0);
